import React from "react";
import { useColorScheme } from "@mui/material/styles";
import { Box, FormControlLabel, Switch } from "@mui/material";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined"; // Light theme icon
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined"; // Dark theme icon

export default function ColorModeSwitch() {
  const { mode, setMode } = useColorScheme();

  if (!mode) {
    return null;
  }

  const handleChange = () => {
    setMode(mode === "light" ? "dark" : "light");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      {mode === "light" ? (
        <WbSunnyOutlinedIcon sx={{ color: "#FFC107" }} />
      ) : (
        <DarkModeOutlinedIcon sx={{ color: "#607D8B" }} />
      )}
      <FormControlLabel
        control={
          <Switch
            checked={mode === "dark"}
            onChange={handleChange}
            sx={{
              "& .MuiSwitch-track": {
                backgroundColor: mode === "dark" ? "#607D8B" : "#FFC107",
              },
              "& .MuiSwitch-thumb": {
                transition: "all 0.3s ease",
              },
            }}
          />
        }
        label=""
      />
    </Box>
  );
}
